import gazetteer, { defaultLocale } from '@bridebook/toolbox/src/gazetteer';
import { languageTags } from '@bridebook/web/lib/i18n/constants';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const path = require('path');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const ChainedBackend = require('i18next-chained-backend').default;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const HttpBackend = require('i18next-http-backend/cjs');

const isBrowser = typeof window !== 'undefined';
const fs = isBrowser ? null : require('fs');

const ns = isBrowser
  ? []
  : fs
      .readdirSync(`./public/locales/en-GB/`)
      .map((file) => (file.endsWith('.json') ? file.replace('.json', '') : null))
      .filter(Boolean);

/** @type {import('i18next').InitOptions} */
module.exports = {
  i18n: {
    defaultLocale,
  },
  backend: {
    backends: isBrowser ? [HttpBackend] : [],
    backendOptions: isBrowser
      ? [
          {
            loadPath: (locale, namespace) => {
              const languageTag = (() => {
                if (process.env.NEXT_PUBLIC_CROWDIN_IN_CONTEXT) {
                  return 'ach-UG';
                }

                return languageTags[locale] || locale;
              })();

              return `/locales/${languageTag}/${namespace}.json`;
            },
          },
        ]
      : [],
  },
  localePath: (locale, namespace) => {
    const languageTag = (() => {
      if (process.env.NEXT_PUBLIC_CROWDIN_IN_CONTEXT) {
        return 'ach-UG';
      }

      return languageTags[locale] || locale;
    })();

    return path.resolve(`./public/locales/${languageTag}/${namespace}.json`);
  },
  supportedLngs: [
    ...gazetteer.getMarkets({ translated: true }).map((market) => market.locale),
    defaultLocale,
  ],
  /**
   * Whether to support simpler variants (e.g.: `en`) as supported when the main language (e.g.: `en-US`) isn't.
   */
  nonExplicitSupportedLngs: false,
  ns,
  debug: false,
  // @see https://www.i18next.com/principles/fallback#fallback-to-different-languages
  fallbackLng: (code) => {
    const result = [defaultLocale];

    if (typeof code === 'string') {
      const language = code.substring(0, 2).toLowerCase();

      /**
       * Fallback to German if the locale is a German based locale.
       * This is currently used for Austria and Switzerland German variants.
       */
      if (language === 'de') {
        // result.unshift('de-DE');
      }
    }

    return result;
  },
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
    format: (value, format) => {
      if (format === 'possessive') {
        if (typeof value !== 'string' || !value) return '';
        return value.toLowerCase().endsWith('s') ? `${value}'` : `${value}'s`;
      }
      return value;
    },
  },
  // This uses the same approach as the official example, to be able to provide
  // config:
  // https://github.com/i18next/i18next-http-backend/blob/master/example/next/next-i18next.config.js
  use: isBrowser ? [ChainedBackend] : [],
  serializeConfig: false,
};
